export enum UserType {
  Admin = 'ADMIN',
  User = 'USER',
  Support = 'SUPPORT',
  RBAC = 'RBAC',
  None = 'NONE'
}
